module.exports = [{
      plugin: require('../../../node_modules/gatsby-plugin-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://www.captain-bob.app"},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Captain Bob","short_name":"Captain Bob","description":"L’Application dédiée à la pratique des sports & des loisirs","lang":"fr","display":"standalone","icon":"src/assets/images/logos/favicon.svg","icon_options":{"purpose":"any maskable"},"start_url":"/","background_color":"#ffffff","theme_color":"#000000","localize":[{"start_url":"/en/","lang":"en","name":"Captain Bob","short_name":"Captain Bob","description":"The 1st App dedicated to sports practice & hobbies"}],"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"0742bc1196d5161a329f424f4a15dd6f"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
